// extracted by mini-css-extract-plugin
module.exports = {"button":"RemoveCartItemButton_button__aU9bQ"};